// Defaults for the postgres integration
export const POSTGRES_INTEGRATION_DEFAULT_RETRY_COUNT = 3;
